import { HALApiService } from '../hal-api.service'
import { createItemsData } from '../../helpers/request-helpers'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const integrationCategoryService = new CachedService(entities.Orderadmin_Integrations_Entity_Category, '/integrations/category', HALApiService, createItemsData)
